// ink-component
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { StyledTwiddleIconButton } from './styles';

import Icon from '../../../../../Icon/Icon';
import { useTwiddleIconState } from '../../hooks';

export interface TwiddleIconPropsType extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Twiddle icon state override */
  isOpen?: boolean;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

/**
 * @purpose Icon used to Collapse or Expand all Rows
 * @group NewTableTwiddle
 */
const TwiddleIcon = ({ style, className, isOpen, onClick, ...otherProps }: TwiddleIconPropsType) => {
  const { open, level } = useTwiddleIconState();

  const themeContext = useContext(ThemeContext);

  // If a user is controlling the twiddle state from an external source, they can use
  // the isOpen prop to override the open state of the twiddle icon.

  return (
    <StyledTwiddleIconButton {...otherProps} theme={{ ...themeContext, open, level }} type="button" onClick={onClick}>
      <Icon type="forward" meaning={open ? 'Collapse row' : 'Expand row'} />
    </StyledTwiddleIconButton>
  );
};

TwiddleIcon.displayName = 'NewTable.Twiddle.Icon';

export default TwiddleIcon;
